import WebsiteModal from "modal/WebsiteModal";

export default class TestimonialSliderModal extends WebsiteModal {
    constructor(clonedElement) {
        super();
        this.$clonedElement = $(clonedElement);
        this.text = this.$clonedElement.find('p').attr('data-content');
    }

    buildElement() {
        this.$modal = (
            eotwJSXFactory('div', {className: "modal modal--testimonial-card"}, [
                eotwJSXFactory('div', {className: "modal__bg js-close-modal"}),
                eotwJSXFactory('div', {className: "modal__container modal__container--900"}, [
                    eotwJSXFactory('button', {className: "modal__close js-close-modal"}),
                    this.$clonedElement
                ])
            ])
        );

        this.$modal.find('.testimonial-card__content').text(this.text).attr('data-content', '');
    }
}
